/**
 * D4F QUALITY GUARANTEE
 * - SVG Icon Masking für Farb-Kontrolle
 * - Scroll Animations
 * - Counter Animations für Garantie-Jahre
 * - Intersection Observer
 */
(function () {
  const sections = document.querySelectorAll('.d4f-quality-guarantee');
  
  sections.forEach(section => {
    initQualityGuarantee(section);
  });

  function initQualityGuarantee(section) {
    // Setup SVG Masking für alle Icons
    setupIconMasks(section);

    // Setup Scroll Animations
    setupScrollAnimations(section);

    // Setup Counter Animations (falls Zahlen in Texten vorhanden)
    setupCounterAnimations(section);
  }

  /**
   * Setup SVG Icons als CSS Masks für Farbsteuerung
   */
  function setupIconMasks(section) {
    // Quality Seal Icon
    const sealIcon = section.querySelector('.d4f-quality-seal__icon');
    if (sealIcon) {
      setupSingleIcon(sealIcon, '.d4f-quality-seal__icon-img');
    }

    // Highlight Card Icons
    const highlightIcons = section.querySelectorAll('.d4f-highlight-card__icon');
    highlightIcons.forEach(icon => {
      setupSingleIcon(icon, '.d4f-highlight-card__icon-img');
    });

    // Material Card Icons
    const materialIcons = section.querySelectorAll('.d4f-material-card__icon');
    materialIcons.forEach(icon => {
      setupSingleIcon(icon, '.d4f-material-card__icon-img');
    });

    // Warranty Panel Icon
    const warrantyIcon = section.querySelector('.d4f-warranty-panel__icon');
    if (warrantyIcon) {
      setupSingleIcon(warrantyIcon, '.d4f-warranty-panel__icon-img');
    }

    // Quality Feature Icons (Blocks)
    const featureIcons = section.querySelectorAll('.d4f-quality-feature-item__icon');
    featureIcons.forEach(icon => {
      setupSingleIcon(icon, '.d4f-quality-feature-item__icon-img');
    });
  }

  function setupSingleIcon(wrapper, imgSelector) {
    const img = wrapper.querySelector(imgSelector);
    if (!img || !img.src) return;

    // Check if PNG/JPG
    const isPNG = img.src.toLowerCase().match(/\.(png|jpg|jpeg|gif|webp)$/);
    
    if (isPNG) {
      wrapper.classList.add('d4f-icon--png');
      return;
    }

    // For SVG: Set mask-image
    wrapper.style.webkitMaskImage = `url(${img.src})`;
    wrapper.style.maskImage = `url(${img.src})`;
  }

  /**
   * Setup Scroll Animations mit Intersection Observer
   */
  function setupScrollAnimations(section) {
    if (!('IntersectionObserver' in window)) return;

    const animatedElements = section.querySelectorAll(
      '.d4f-highlight-card, .d4f-material-card, .d4f-quality-feature-item'
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '50px'
      }
    );

    animatedElements.forEach((element, index) => {
      element.style.opacity = '0';
      element.style.transform = 'translateY(30px)';
      element.style.transition = `opacity 0.6s ease ${index * 0.1}s, transform 0.6s ease ${index * 0.1}s`;
      observer.observe(element);
    });

    // Animate Warranty Panel
    const warrantyPanel = section.querySelector('.d4f-warranty-panel');
    if (warrantyPanel) {
      const warrantyObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.style.opacity = '1';
              entry.target.style.transform = 'scale(1)';
              warrantyObserver.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.2
        }
      );

      warrantyPanel.style.opacity = '0';
      warrantyPanel.style.transform = 'scale(0.95)';
      warrantyPanel.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      warrantyObserver.observe(warrantyPanel);
    }
  }

  /**
   * Setup Counter Animations für Zahlen in Texten
   * Sucht nach Zahlen wie "10 Jahre", "100% Garantie", etc.
   */
  function setupCounterAnimations(section) {
    if (!('IntersectionObserver' in window)) return;

    // Finde alle Textelemente die Zahlen enthalten könnten
    const textElements = section.querySelectorAll(
      '.d4f-highlight-card__title, .d4f-warranty-panel__title'
    );

    textElements.forEach(element => {
      const text = element.textContent;
      
      // Suche nach Zahlen im Text (z.B. "10", "100", "5")
      const numberMatch = text.match(/\b(\d+)\b/);
      
      if (numberMatch) {
        const targetNumber = parseInt(numberMatch[1]);
        const originalText = text;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting && !element.dataset.animated) {
                element.dataset.animated = 'true';
                animateCounter(element, 0, targetNumber, originalText, 1000);
                observer.unobserve(entry.target);
              }
            });
          },
          {
            threshold: 0.5
          }
        );

        observer.observe(element);
      }
    });
  }

  function animateCounter(element, start, end, template, duration) {
    const range = end - start;
    const steps = 30;
    const increment = range / steps;
    const stepDuration = duration / steps;
    let current = start;

    const interval = setInterval(() => {
      current += increment;
      
      if (current >= end) {
        element.textContent = template;
        clearInterval(interval);
      } else {
        const displayNumber = Math.floor(current);
        element.textContent = template.replace(/\b\d+\b/, displayNumber);
      }
    }, stepDuration);
  }

  /**
   * Add pulse effect to quality seal on scroll
   */
  function setupSealAnimation(section) {
    const seal = section.querySelector('.d4f-quality-seal__icon');
    if (!seal) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            seal.style.animation = 'pulse-seal 3s ease-in-out infinite';
          }
        });
      },
      {
        threshold: 0.5
      }
    );

    observer.observe(seal);
  }

  sections.forEach(section => {
    setupSealAnimation(section);
  });

  /**
   * Enhance warranty panel interaction
   */
  function enhanceWarrantyPanel(section) {
    const warrantyPanel = section.querySelector('.d4f-warranty-panel');
    if (!warrantyPanel) return;

    let mouseX = 0;
    let mouseY = 0;
    let ticking = false;

    warrantyPanel.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;

      if (!ticking) {
        window.requestAnimationFrame(() => {
          updatePanelGradient(warrantyPanel, mouseX, mouseY);
          ticking = false;
        });

        ticking = true;
      }
    });
  }

  function updatePanelGradient(panel, x, y) {
    const rect = panel.getBoundingClientRect();
    const relX = ((x - rect.left) / rect.width) * 100;
    const relY = ((y - rect.top) / rect.height) * 100;

    panel.style.background = `
      radial-gradient(
        circle at ${relX}% ${relY}%,
        rgba(212, 165, 116, 0.2),
        rgba(212, 165, 116, 0.08)
      )
    `;
  }

  sections.forEach(section => {
    enhanceWarrantyPanel(section);
  });

  /**
   * Trust Icons Hover Effect Enhancement
   */
  function enhanceTrustIcons(section) {
    const icons = section.querySelectorAll('.d4f-trust-icon');
    
    icons.forEach(icon => {
      icon.addEventListener('mouseenter', () => {
        icons.forEach(i => {
          if (i !== icon) {
            i.style.opacity = '0.5';
          }
        });
      });

      icon.addEventListener('mouseleave', () => {
        icons.forEach(i => {
          i.style.opacity = '1';
        });
      });
    });
  }

  sections.forEach(section => {
    enhanceTrustIcons(section);
  });

  /**
   * Analytics Tracking (optional)
   */
  function trackGuaranteeInteraction(action, label) {
    // Google Analytics
    if (window.gtag) {
      window.gtag('event', 'quality_guarantee_interaction', {
        action: action,
        label: label
      });
    }

    // Facebook Pixel
    if (window.fbq) {
      window.fbq('trackCustom', 'QualityGuaranteeInteraction', {
        action: action,
        label: label
      });
    }

    console.log('[D4F] Quality Guarantee:', action, label);
  }

  // Track warranty CTA clicks
  sections.forEach(section => {
    const warrantyCTA = section.querySelector('.d4f-warranty-cta-btn');
    if (warrantyCTA) {
      warrantyCTA.addEventListener('click', () => {
        trackGuaranteeInteraction('click', 'warranty_cta');
      });
    }
  });

  /**
   * Lazy Load Trust Icon Images
   */
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('.d4f-trust-icon__img');
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          imageObserver.unobserve(img);
        }
      });
    });

    lazyImages.forEach(img => imageObserver.observe(img));
  }

  /**
   * Add tooltips to trust icons (optional enhancement)
   */
  function addIconTooltips(section) {
    const icons = section.querySelectorAll('.d4f-trust-icon');
    
    icons.forEach(icon => {
      const img = icon.querySelector('.d4f-trust-icon__img');
      if (img && img.alt) {
        icon.setAttribute('title', img.alt);
        icon.style.cursor = 'help';
      }
    });
  }

  sections.forEach(section => {
    addIconTooltips(section);
  });

  /**
   * Highlight active material card on hover (grouped effect)
   */
  function setupMaterialCardsGroupEffect(section) {
    const materialCards = section.querySelectorAll('.d4f-material-card');
    
    materialCards.forEach(card => {
      card.addEventListener('mouseenter', () => {
        materialCards.forEach(c => {
          if (c !== card) {
            c.style.opacity = '0.6';
          }
        });
      });

      card.addEventListener('mouseleave', () => {
        materialCards.forEach(c => {
          c.style.opacity = '1';
        });
      });
    });
  }

  sections.forEach(section => {
    setupMaterialCardsGroupEffect(section);
  });

  /**
   * Progressive Enhancement: Add micro-interactions
   */
  function addMicroInteractions(section) {
    // Add subtle scale on click for highlight cards
    const highlightCards = section.querySelectorAll('.d4f-highlight-card');
    
    highlightCards.forEach(card => {
      card.addEventListener('click', () => {
        card.style.transform = 'scale(0.98) translateY(-4px)';
        setTimeout(() => {
          card.style.transform = 'translateY(-4px)';
        }, 150);
      });
    });
  }

  sections.forEach(section => {
    addMicroInteractions(section);
  });
})();